import { render, staticRenderFns } from "./CustomerJobDetail.vue?vue&type=template&id=5cdf0b66&"
import script from "./CustomerJobDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerJobDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports